import { render, staticRenderFns } from "./EditCostumerRelation.vue?vue&type=template&id=5e921275&"
import script from "./EditCostumerRelation.vue?vue&type=script&lang=js&"
export * from "./EditCostumerRelation.vue?vue&type=script&lang=js&"
import style0 from "./EditCostumerRelation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports